export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manae.5f1fc5d9.svg","height":101,"width":102,"blurWidth":0,"blurHeight":0};